import { render } from "./DownloaderGroupSelect.vue?vue&type=template&id=1d41916c&scoped=true"
import script from "./DownloaderGroupSelect.vue?vue&type=script&lang=js"
export * from "./DownloaderGroupSelect.vue?vue&type=script&lang=js"

import "./DownloaderGroupSelect.vue?vue&type=style&index=0&id=1d41916c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d41916c"]])

export default __exports__